/**
 * Typed CMS content for /lens-calculator.
 *
 * Source: content/pages/lens-calculator/page.html
 * Production capture: output/page-rebuild/lens-calculator/
 *
 * Interactive lens calculator. Static UI shell is rendered server-side
 * (`<form>` with SIZE select, D + W text inputs, Calculate button, EQL
 * hidden input, and result placeholder). The client-side computation is
 * hydrated by `LensCalculatorClient` — formula matches the second `doit()`
 * function from the source `<script>` block:
 *
 *   eql_mm = round((D / W) * SIZE * 100) / 98, rounded to 1 decimal.
 *
 * Source has no <h1>/<h2>/<p> — the parity gate just checks for one form
 * with the exact field shape (SIZE select, D text, W text, type=button,
 * EQL hidden) and the lens-calculator-diagram.jpg image. We still emit
 * an <h1> with the page's contentHeading so the typed page satisfies the
 * project-wide "exactly one <h1>" rule.
 */

import type { BreadcrumbItem } from '@/components/cms/Breadcrumbs';

export const metadata = {
  metaTitle: 'Security Camera Lens Calculator',
  description:
    'A CCTV lens calculator can help you figure out what type of lens you need on your security camera. This surveillence lens calculator will help you determine the appropriate chipsets and distances for your CCTV application.',
  keywords: 'security camera lens calculator, lens calculator, cctv lens calculator',
};

export const breadcrumbs: BreadcrumbItem[] = [
  { label: 'Home', href: 'https://www.getscw.com/' },
  { label: 'Security Camera Lens Calculator' },
];

export const breadcrumbsBlockId = 'lens-calculator.breadcrumbs';

export const hero = {
  blockId: 'lens-calculator.hero',
  title: 'Security Camera Lens Calculator',
};

export interface CcdOption {
  value: string;
  label: string;
  selected?: boolean;
}

export const ccdOptions: CcdOption[] = [
  { value: '3.2', label: '1/4"' },
  { value: '4.8', label: '1/3"', selected: true },
  { value: '.5', label: '1/2"' },
];

export const diagram = {
  src: 'https://scw-commerce-media.s3.amazonaws.com/images/lens-calculator-diagram.jpg',
  sourceSrc: 'https://scw-commerce-media.s3.amazonaws.com/images/lens-calculator-diagram.jpg',
  alt: 'security camera lens calculator diagram',
  width: 250,
  height: 200,
};

export const labels = {
  ccd: 'Size of CCD',
  distance: 'Distance to Target',
  width: 'Width of View',
  unit: 'ft',
  calculateValue: ' Calculate Lens ',
  resultHeading: 'Lens Required',
  resultPlaceholderHint: 'Enter Distance to Target & Width of View',
  resultPlaceholderValue: '0.00',
};
